import { useState } from 'react';
import { Building2 } from 'lucide-react';

interface CompanyLogoProps {
  src?: string;
  alt: string;
  className?: string;
}

export default function CompanyLogo({ src, alt, className = '' }: CompanyLogoProps) {
  const [hasError, setHasError] = useState(false);

  // Show fallback if no src or if image failed to load
  if (!src || hasError) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center flex-shrink-0 ${className}`}>
        <Building2 className="w-1/2 h-1/2 text-gray-400" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setHasError(true)}
      className={`object-cover flex-shrink-0 ${className}`}
    />
  );
}








